import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolTower = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 13,
	viewBox: "0 0 9 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.72883 0V1.51215H5.04591V0H3.36585V1.51215H1.68292V0H0V1.51215L0.0287206 9.73963L4.21306 13L8.41176 9.78429V7.5735L5.60306 5.42969L8.41176 3.29865V1.51215V0H6.72883Z",
		fill: "currentColor"
	})
});
export default SvgLolTower;
